import * as React from 'react';
import { useLocalStorage } from '@grandvisionhq/lib-utils-w3c';

const useWishlistStorage = ()=>{
    const [localWishlist, setLocalWishlist, removeLocalWishlist] = useLocalStorage('wishlist');
    return React.useMemo(()=>[
            localWishlist,
            setLocalWishlist,
            removeLocalWishlist
        ]
    , [
        localWishlist,
        setLocalWishlist,
        removeLocalWishlist
    ]);
};

export { useWishlistStorage };
//# sourceMappingURL=use-wishlist-storage.js.map
